import axios from 'axios'
import Config from '../Helpers/Config';
import {requiresRelogin}  from './authActions'

export const updateKeyword = (keyword) => {
    return {
        type: 'UPDATE_PRODUCT_SEARCH_KEYWORD',
        keyword: keyword
    }
};

export const fetchCategoriesByKeyword = (keyword) => {

    return function (dispatch) {
        dispatch({
            type: 'FETCHING_PRODUCT_SEARCH_CATEGORY'
        });

        return axios.get(`${Config.api()}search/category?q=${keyword}`,{
            withCredentials:Config.withCredentials()
        })
            .then((response) => {
                dispatch({
                    type: 'FETCH_PRODUCT_SEARCH_CATEGORY',
                    results: response.data.results
                });
            }).catch((error) => {
                if(error.response.status === 401) {
                    dispatch(requiresRelogin(true, true))
                }else{
                    dispatch({
                        type: 'FETCHING_PRODUCT_SEARCH_CATEGORY_FAILED'
                    });
                }
            });
    };
};

export const fetchProducts = (keyword, categoryId, scrollId, isNewCategory) => {
    let url = Config.api() + 'search/category/' + categoryId + '/products?q=' + keyword;

    if (!isNewCategory && scrollId) {
        url = url + '&page=' + scrollId;
    }

    return function (dispatch) {
        dispatch({
            type: 'FETCHING_PRODUCT_SEARCH'
        });
        return axios.get(url,{
            withCredentials:Config.withCredentials()
        }).then((response) => {
                dispatch({
                    type: 'FETCH_PRODUCT_SEARCH',
                    results: response.data,
                    // results: response.data.results
                });
            }).catch((error) => {
                if(error.response.status === 401) {
                    dispatch(requiresRelogin(true, true))
                }else{
                    dispatch({
                        type: 'FETCHING_PRODUCT_SEARCH_FAILED'
                    });
                }
            });
    };
};

